import { render, staticRenderFns } from "./NotificationCardForComment.vue?vue&type=template&id=c0438eb0&scoped=true&"
import script from "./NotificationCardForComment.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForComment.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForComment.vue?vue&type=style&index=0&id=c0438eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0438eb0",
  null
  
)

export default component.exports